export const DocBayPatientLandingLink =
  process.env.REACT_APP_DOCBAY_LANDING_LINK || '';

export const DocBaySupportLink =
  process.env.REACT_APP_DOCBAY_SUPPORT_LINK || '';
